export const homeReducerSelector = state => state.homeReducer;
